<template>
  <div class="group">
    <!-- 悬浮按钮-->
    <img
      v-for="(item, index) in items"
      :key="index"
      :style="itemStyle(index)"
      :src="item && item.icon && item.icon.url"
      @click="onItemClick(index, item)"
      alt/>

    <img
      v-if="backTopVisible"
      :style="itemStyle(-1, true)"
      :src="backTopIcon"
      @click="backTop"
      alt/>

    <!-- 弹框  -->
    <div
      class="popup-img-container"
      v-if="showPopupImg"
      @click="showPopupImg=false">
      <img
        class="popup-img"
        :src="popupImg"
        alt/>

      <img
        class="popup-close"
        :src="btnCloseIcon"
        alt/>
    </div>
  </div>
</template>

<script>
import {calcRem} from "@/pages/Campaign/utils/calcRem"
import {UNI_ROUTE} from '@/pages/Campaign/utils/uniRoute'
import backTopIcon from '@/pages/Campaign/assets/back-top.png'
import btnCloseIcon from '@/pages/Campaign/assets/popup-close.png'

export default {
  name: "FloatButtonGroup",
  props: {
    // 是否显示
    backTopVisible: {
      type: Boolean,
      default: false
    },
    // 子条目数组
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showPopupImg: false,
      popupImg: '',
      backTopIcon,
      btnCloseIcon
    }
  },
  methods: {
    itemStyle(index, isBackTop = false) {
      return {
        width: calcRem(50),
        height: calcRem(50),
        marginBottom: isBackTop ? calcRem(56) : calcRem(12),
        marginRight: calcRem(14)
      }
    },
    onItemClick(index, item) {
      // 没有配置数据不处理
      if (!item || !item.jumpType) {
        return
      }

      // 展示弹窗
      if (item.jumpType === 'popup') {
        this.popupImg = item && item.popupImg && item.popupImg.url
        this.showPopupImg = true
        return
      }

      // 路由跳转
      if (item.jumpType === 'link') {
        UNI_ROUTE.floatButtonRoute(item)
      }
    },
    backTop() {
      this.$emit('backTop')
    }
  }
}
</script>

<style lang="less" scoped>
.group {
  position: fixed;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .popup-img-container {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #0000002d;

    .popup-img {
      width: 80%;
      margin-top: 120px;
    }

    .popup-close {
      width: 32px;
      height: 32px;
      margin-top: 20px;
    }
  }
}
</style>
